<template>
  <img :src="url" alt="加载中..." />
</template>
<script>
import qrcode from 'qrcode'
export default {
  name: 'QrCode',
  props: {
    value: {
      default: '',
      type: String
    },
    margin: {
      default: 0,
      type: [String, Number]
    },
    width: {
      default: 200,
      type: [String, Number]
    }
  },
  data() {
    return {
      url: ''
    }
  },
  watch: {
    value() {
      this.setQrcode()
    }
  },
  methods: {
    setQrcode() {
      if (!this.value) {
        return console.warn('缺少二维码内容')
      }
      qrcode
        .toDataURL(this.value, { margin: this.margin, width: this.width })
        .then(res => (this.url = res))
    }
  },
  mounted() {
    this.setQrcode()
  }
}
</script>
